<template>
  <div>
    <div class="second-model" @click.prevent="hide()" v-if="channeltime"></div>
    <div class="contions" v-if="channeltime">
      <div class="title">提示</div>
      <div class="content">
        客服小妹一直没收到您的咨询，上次会话已超时关闭。
      </div>
      <div class="btns">
        <div class="back" @click="back()">开启新会话</div>
        <div class="newchannel" @click="newchannel()">退出咨询</div>
      </div>
    </div>
  </div>
</template>

<script>
//二次进入弹框
// import store from "src/app/customer/store";
import canstants from "src/app/customer/constant";
import service from "src/app/customer/service";
import constant from "../../constant";
import globalUtils from "../../utils";
import { closeWindows } from "../../app/customer/utils/win";

export default {
  name: "channel-time-out",
  computed: {
    ...mapState({
      isQueue: state => state.isQueue,
      dialogVisible: state => state.dialogVisible,
      dialogtime: state => state.dialogtime,
      channeltime: state => state.channeltime,
      userId: state => state.userId,
      urlData: state => state.urlData
    })
  },
  data() {
    return {};
  },
  methods: {
    hide() {
      this.isSeconnd = false;
    },
    async back() {
      this.$store.commit("setState", {
        triggerId: canstants.WakeUpScene.ordinary,
        enterScene: canstants.WakeUpScene.ordinary,
        serverAvatar: constant.testAccount.defaultPhoto,
        channeltime: false,
        isload: true
      });
      if (this.urlData.enterScene == 5) {
        this.$store.dispatch("hangupChannel");
        const customerInfo = await this.$store.dispatch(
          "collectCustomerInfo",
          this.urlData
        );
        if (customerInfo) {
          Object.keys(customerInfo.data).forEach(key => {
            globalUtils.setProp(key, customerInfo.data[key]);
          });
          this.urlData.userId = customerInfo.data.userId;
          this.urlData.userName = customerInfo.data.userName;

          this.$store.commit("setState", {
            alreadyLogin: true,
            customerInfo: customerInfo.data,
            // hasHistory: true,
            urlData: this.urlData
          });
          // token
          this.$store.commit("setState", customerInfo.data);
        }
        console.log("customerInfo", customerInfo);
        // 获取时间戳
        await service.queryServerConfig().then(res => {
          if (res) {
            if (res.code == 200 && res.data) {
              sessionStorage.setItem("serverTime", res.data.dateTime);
            }
          }
        });
        this.$store.dispatch("initChannel", {
          orderImgUrls: "",
          router: this.$router
        });
      } else {
        console.log("开启新会话", constant.testAccount.defaultPhoto);

        const { data: questionTypes } = await service.queryCusSkill();
        this.$store.commit("setState", { questionTypes });
        this.$router.push("before-page");
      }
    },
    newchannel() {
      closeWindows();
    }
  }
};
</script>

<style lang="less" scoped>
.second-model {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
}
.contions {
  z-index: 100;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 320px;
  height: 200px;
  background: var(--pages-bg);
  border: 1px solid #cccccc;
  border-radius: 5px;
  .title {
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-bottom: 1px solid #ccc;
    font-size: 16px;
    background: var(--model-title-bg);
    color: var(--model-title);
  }
  .content {
    padding: 24px 24px 15px;
    line-height: 24px;
    color: var(--model-text);
  }
  .btns {
    text-align: center;
    .back {
      width: 100px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 14px;
      margin: 0 auto;
      border-radius: 3px;
      color: var(--emoji-bg-color);
      background: var(--button-bg);
      cursor: pointer;
      margin-bottom: 10px;
      -webkit-tap-highlight-color: transparent;
    }
    .newchannel {
      color: var(--button-bg);
      cursor: pointer;
      font-size: 14px;
      -webkit-tap-highlight-color: transparent;
      margin-bottom: 10px;
    }
  }
}
</style>
